

































import Vue from 'vue'
import isEqual from 'lodash.isequal'
import RadioButton from '@/components/globals/basics/RadioButton.vue'
import { Gender } from '@/core/Programs'

export default Vue.extend({
  components: {
    RadioButton,
  },
  props: {
    value: {
      type: Array as () => Gender[],
      default: [],
    },
    hideClear: {
      type: Boolean as () => boolean,
      default: false,
    },
  },
  data: () => ({
    Gender,
  }),
  methods: {
    onChange(value: Gender) {
      // 同じ値なら連打防止のため何もしない
      if (isEqual(value, this.value)) return

      const newValue = this.value.includes(value)
        ? this.value.filter((v) => v !== value)
        : [...this.value, value]
      this.$emit('onChange', newValue)
    },
  },
})
